import { useState } from "react";
import { useTranslation } from "react-i18next";
import ToolkitAppScroller from "components/BeyondToolkit/ToolkitAppScroller";
import CountdownCard from "components/Timer/CountdownCard";
import CustomTimeModal from "components/Timer/CustomTimeModal";
import TimerOptions from "components/Timer/TimerOptions";
import { TIMER } from "utils/beyondToolkitTools";

function Timer() {
  // this tells i18next to load these namespaces
  const { ready } = useTranslation(["dojo.beyond"]);

  const [display, setDisplay] = useState("default");
  const [seconds, setSeconds] = useState<number | null>(null);
  const [showCustomModal, setShowCustomModal] = useState(false);

  const { color, title, imgSrc } = TIMER();

  const openTimer = (input: number) => {
    setDisplay("timer");
    setSeconds(input);
    setShowCustomModal(false);
  };

  const closeTimer = () => {
    setDisplay("default");
    setSeconds(null);
  };

  const openCustomModal = () => {
    setShowCustomModal(true);
  };

  const closeCustomModal = () => {
    setShowCustomModal(false);
  };

  if (!ready) return null;

  return (
    <ToolkitAppScroller title={title} color={color} imgSrc={imgSrc}>
      {display === "timer" && <CountdownCard goBack={closeTimer} seconds={seconds ?? 0} />}
      {display === "default" && <TimerOptions openTimer={openTimer} openCustomModal={openCustomModal} />}
      {showCustomModal && <CustomTimeModal startTimer={openTimer} goBack={closeCustomModal} />}
    </ToolkitAppScroller>
  );
}

export default Timer;
